import { resolveTimeSeriesLegendSeries } from '../../utils/legendSeries';
import {
	SectionKind,
	ThresholdVariant,
	type SectionConfig,
} from '../../types/sections';

// Declaring `fillOpacity` also makes the kind always-filled: `fillMode` drops `none`
// and defaults to solid.
export const sections: SectionConfig[] = [
	{
		kind: SectionKind.Visualization,
		controls: {
			switchPanelKind: true,
			timePreference: true,
			stackMode: true,
			fillSpans: true,
		},
	},
	{ kind: SectionKind.Formatting, controls: { unit: true, decimals: true } },
	{ kind: SectionKind.Axes, controls: { minMax: true, logScale: true } },
	{
		kind: SectionKind.Legend,
		controls: { position: true, colors: resolveTimeSeriesLegendSeries },
	},
	{
		kind: SectionKind.ChartAppearance,
		controls: {
			lineStyle: true,
			lineInterpolation: true,
			fillMode: true,
			fillOpacity: true,
			showPoints: true,
			spanGaps: true,
		},
	},
	{
		kind: SectionKind.Thresholds,
		controls: { variant: ThresholdVariant.LABEL },
	},
	{ kind: SectionKind.ContextLinks },
];
